import { DashboardComponentsSidebarAddWidgetsState, DashboardComponentsSidebarAddWidgetsWidgetCategories, initialDashboardComponentsSidebarAddWidgetsState } from '@/modules/dashboard-module/components/sidebar-add-widgets/dashboard-components-sidebar-add-widgets.model'
import { DashboardModuleBaseAreaEnumActions } from '@/modules/dashboard-module/shared/components/base-area/dashboard-module-shared-components-base-area.model'
import { getWidgetSectionAllWidgetsOption, getWidgetSections, hasSectionAccess } from '@/modules/dashboard-module/shared/models/dashboard-module.helpers'
import { DashboardModuleArea, DashboardModuleLayoutWidget, DashboardModuleSection, DashboardModuleSectionsWidgets } from '@/modules/dashboard-module/shared/models/dashboard-module.model'
import { store } from '@/store/store'
import { BSidebar } from 'bootstrap-vue'
import { cloneDeep } from 'lodash'
import { Vue, Component, Ref } from 'vue-property-decorator'

@Component({
    components: {
    }
})
export default class DashboardComponentsSidebarAddWidgets extends Vue {
    @Ref() readonly dashboardSidepanelAdd!: BSidebar

    state: DashboardComponentsSidebarAddWidgetsState
    constructor() {
        super()
        this.state = initialDashboardComponentsSidebarAddWidgetsState()
    }

    beforeDestroy() {
        this.state.unsubscribe()
    }

    show(): void {
        this.state.show = true
        this._getFilteredSections()
        this._getFilteredCategories(this.state.filter.selected!)
        this.state.unsubscribe = store.subscribeAction(async (action) => {
            if (action.type === DashboardModuleBaseAreaEnumActions.DASHBOARD_ADD_WIDGET || action.type === DashboardModuleBaseAreaEnumActions.DASHBOARD_REMOVE_WIDGET) {
                this._getFilteredCategories(this.state.filter.selected!)
            }
        })
    }

    hide(): void {
        this.state.show = false
        this.state.unsubscribe()
    }

    onChangeFilter(option: DashboardModuleSectionsWidgets): void {
        this._getFilteredCategories(option)
    }

    async addWidget(widget: DashboardModuleLayoutWidget): Promise<void> {
        widget.hidden = false
        await store.dispatch('dashboard/addWidgetAndSetVisible', widget)
    }

    async removeWidget(widget: DashboardModuleLayoutWidget): Promise<void> {
        widget.hidden = true
        await store.dispatch('dashboard/removeWidgetAndSetVisible', widget)
    }

    async changeVisibilityWidget(widget: DashboardModuleLayoutWidget): Promise<void> {
        return widget.hidden ? this.addWidget(widget) : this.removeWidget(widget)
    }

    private _getFilteredSections(): void {
        let allowedSections = getWidgetSections().reduce((aggr, item) => {
            if (hasSectionAccess(item?.id)) {
                aggr.push(item)
            }
            return aggr
        }, [] as DashboardModuleSectionsWidgets[])
        if (allowedSections.length > 1) {
            allowedSections = getWidgetSectionAllWidgetsOption().concat(allowedSections)
        }
        this.state.filter.list = allowedSections
        this._setFilteredSelectedSection()
    }

    private _setFilteredSelectedSection(): void {
        this.state.filter.selected = this.state.filter.list.length
            ? this.state.filter.list[0] : null
    }

    private _getWidgetsFilteredByCategory(category: DashboardModuleArea, filter: DashboardModuleSectionsWidgets): DashboardModuleLayoutWidget[] {
        const allWidgets = cloneDeep(store.getters['dashboard/allWidgets'])
        const filterWidgetsByAccess = allWidgets.filter((widget: DashboardModuleLayoutWidget) => hasSectionAccess(widget.section))
        let filteredWidgetsByCategory = filterWidgetsByAccess.filter((widget: DashboardModuleLayoutWidget) => widget.area === category)

        if (filter.id === DashboardModuleSection.ALL) {
            return filteredWidgetsByCategory
        } else {
            return filteredWidgetsByCategory.filter((widget: DashboardModuleLayoutWidget) => widget.section === filter.id)
        }
    }

    private _getFilteredCategories(filter: DashboardModuleSectionsWidgets): void {
        this.state.categories.forEach((category: DashboardComponentsSidebarAddWidgetsWidgetCategories) => {
            category.widgets = this._getWidgetsFilteredByCategory(category.id, filter)
            return category
        })
    }
}
